const statusOptions = [
  { value: 'public',  label: 'Public' },
  { value: 'draft',   label: 'Draft' },
  { value: 'expired', label: 'Expired' },
];

export default statusOptions;
